// @flow

// Libs
import _indexOf from 'lodash/indexOf'
import _omit from 'lodash/omit'

import type {
  ComposeDataTableOptions,
  ActionTypes,
  DataTableState,
} from '../../types'

type State = {
  table: DataTableState,
}

// Exports
export default function composeReducers ({
  options,
  actionTypes,
  }: {
  options: ComposeDataTableOptions,
  actionTypes: ActionTypes,
}): {[string]: (state: State, payload: *) => State } {
  //
  const {
    // allowGrouping = false,
    // allowColumnOrdering = false,
    allowSelecting = true,
    allowSorting = true,
    allowFiltering = true,
    allowPagination = true,
  } = options

  const reducers = {}

  if (allowPagination) {
    const paginate = function paginate (
      state: State, payload: number
    ): State {
      //
      return {
        ...state,
        table: {
          ...state.table,
          page: payload,
        },
      }
    }

    reducers[actionTypes.paginate] = paginate
  }

  if (allowSelecting) {
    const select = function select (
      state: State, payload: Array<number>
    ): State {
      // If deselecting
      const removeIds = state.table.selectedRecords
        .filter(function (recordId: number): boolean {
          return _indexOf(payload, recordId) >= 0
        })

      return {
        ...state,
        table: {
          ...state.table,
          selectedRecords: [...state.table.selectedRecords, ...payload]
            .filter(function (recordId: number): boolean {
              return _indexOf(removeIds, recordId) < 0
            }),
        },
      }
    }

    reducers[actionTypes.select] = select
  }

  if (allowSorting) {
    const sort = function sort (
      state: State, { attr, sortAs, booleanAttr, groupBy, groupOrder }: Object
    ): State {
      let sortBy = null
      let sortDesc = state.table.sortDesc
      if (state.table.sortBy === attr) {
        if (state.table.sortDesc === true) {
          sortBy = null
          sortDesc = false
        } else {
          sortBy = attr
          sortDesc = true
        }
      } else {
        sortBy = attr
        sortDesc = false
      }

      return {
        ...state,
        table: {
          ...state.table,
          sortBy,
          sortDesc,
          sortAs,
          booleanAttr,
          groupBy,
          groupOrder,
        },
      }
    }

    reducers[actionTypes.sort] = sort
  }

  if (allowFiltering) {
    const filter = function filter (
      state: State,
      payload: { attr: string, value: string },
    ): State {
      // If filter by value is not falsy
      if (payload.value) {
        return {
          ...state,
          table: {
            ...state.table,
            page: 0,
            filters: {
              ...state.table.filters,
              [payload.attr]: payload.value,
            },
          },
        }
      }

      return {
        ...state,
        table: {
          ...state.table,
          filters: _omit(state.table.filters, payload.attr),
        },
      }
    }

    reducers[actionTypes.filter] = filter
  }

  const resetDataTableState = function (state: State): State {
    return {
      ...state,
      table: {
        ...state.table,
        filters: {},
        page: 0,
        selectedRecords: [],
        sortBy: null,
      },
    }
  }

  reducers[actionTypes.resetDataTableState] = resetDataTableState

  return reducers
}
